import React, { Fragment, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import BotonVerArchivoComponent from './BotonesComponent/BotonVerPdfComponent';
import BotonRechazarDictamenComponent from './BotonesComponent/BotonRechazarDictamenComponent';
import GenerarCertificadoFC13Component from './FormatosComponent/GenerarCertificadoFC13Component';
import GenerarCertificadoFC37Component from './FormatosComponent/GenerarCertificadoFC37Component';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import DictamenCumplimientoFC27Component from './FormatosComponent/DictamenCumplimientoFC27Component';
import RevisionEvaluacionDecisionComponent from './FormatosComponent/RevisionEvaluacionDecisionComponent';
import ModalMensajeComponent from './BotonesComponent/ModalMensajeComponent';
import { obtenerDictamen, obtenerSolicitudesFC01SeguimientoNacionalAdmin, obtenerSolicitudesFC01SeguimientoNacionalAuxiliar } from '../../../../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck';
import PDFMerger from 'pdf-merger-js/browser';
import { host } from '../../../../../../configuraciones';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import Modal from '@mui/material/Modal';
import { AceptarSolicitudFC_01, actualizarFC01_OCAccion } from '../../../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import FormularioDocumentacion from './FormularioDocumentacion';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../../../redux/AppDucks';
import { useHistory } from 'react-router-dom';

const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '70%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};
function DocumentacionGeneralComponent(props) {
    const history = useHistory();

    let detalleCliente = props?.detalle
    const fechaHoy = moment().format('YYYY-MM-DD')
    const informacionCliente = useSelector(store => store.SolicitudesFC01_OC.informacionCliente)
    let rowsDocumentacionGeneral = []
    let rowsDocumentacionArchivosGenerales = []
    const dataUser = useSelector(store => store.Usuario.user)

    const dispatch = useDispatch()
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nameDoc: 'FORMATOS SOLICITUD DE REGISTRO'
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Solicitud de inscripción', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: false, idoficio: 6
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Plan de evaluación', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: false, idoficio: 5
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Solicitud de servicios de inspección', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: false, idoficio: 4
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nameDoc: 'FORMATOS UNIDAD DE INSPECCION'
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Informe de cumplimiento con la NOM', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: false
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Dictamen de cumplimiento con la NOM de instalaciones', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: true
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nameDoc: 'INFORMES CON LA DOCUMENTACION'
    })
    if (detalleCliente?.personamoral) {
        rowsDocumentacionGeneral.push({
            id: uuidv4(), nameDoc: 'Informe con la documentación juridica', tabla: 'documentodictamenfiscal',
            sustituir: false, rechazar: false, idcliente: detalleCliente?.login?.cliente?.[0]?.idcliente
        })
    }
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'idfc01_solicitudregistro',
        idfc01_solicitudregistro: detalleCliente.idfc01_solicitudregistro,
        nameDoc: 'Informe con la documentación fiscal', tabla: 'fc_01_documentos',
        sustituir: false, rechazar: false, idcliente: detalleCliente?.login?.cliente?.[0]?.idcliente
    })
    for (const i in detalleCliente?.login?.cliente?.[0]?.dictamenmarcariocliente) {
        let dictamen = detalleCliente?.login?.cliente?.[0]?.dictamenmarcariocliente?.[i]
        rowsDocumentacionGeneral.push({
            id: uuidv4(), iddictamenmarcariocliente: dictamen?.iddictamenmarcariocliente,
            name: 'Informe con la documentación marcaria',
            nameDoc: 'Informe con la documentación marcaria de la marca: ' + dictamen?.marcaregistrada,
            sustituir: false, rechazar: false, tabla: 'documentodictamenmarcario',
        })
    }

    rowsDocumentacionGeneral.push({
        id: uuidv4(), nameDoc: 'CERTIFICADOS Y CONSTANCIAS'
    })
    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'iddocumento',
        idSolicitud: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc13?.[0]?.ocsolicitudfc01_fc13_documento?.[0]?.iddocumento,
        nameDoc: 'Certificado NOM como productor, envasador, comercializador FC_13', tabla: 'ocsolicitudfc01_fc13_documento',
        sustituir: true, rechazar: false, tipo: 'certificado', idruta: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
    })
    if (informacionCliente?.fc_01_solicitudderegistro?.comercializadormezcal ||
        informacionCliente?.fc_01_solicitudderegistro?.comercializadorbebidasconmezcal) {
        rowsDocumentacionGeneral.push({
            id: uuidv4(), nombreid: 'iddocumento',
            idSolicitud: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc27?.[0]?.ocsolicitudfc01_fc27_documento?.[0]?.iddocumento,
            nameDoc: 'Dictamen de cumplimiento de comercializador FC_27', tabla: 'ocsolicitudfc01_fc27_documento',
            sustituir: true, rechazar: false, tipo: 'certificado', idruta: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
        })
    }

    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'iddocumento',
        idSolicitud: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc37?.[0]?.ocsolicitudfc01_fc37_documento?.[0]?.iddocumento,
        nameDoc: 'Constancia de cumplimiento con la NOM FC_37', tabla: 'ocsolicitudfc01_fc37_documento',
        sustituir: true, rechazar: false, tipo: 'certificado', idruta: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
    })

    rowsDocumentacionGeneral.push({
        id: uuidv4(), nombreid: 'iddocumento',
        idSolicitud: informacionCliente?.ocsolicitudfc01?.[0]?.ocsolicitudfc01_fc11?.[0]?.ocsolicitudfc01_fc11_documento?.[0]?.iddocumento,
        nameDoc: 'Revisión de evaluación y decisión de la certificación', tabla: 'ocsolicitudfc01_fc11_documento',
        sustituir: true, rechazar: false, tipo: 'certificado', idruta: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01,
    })


    const [openModal, setOpenModal] = React.useState(false);
    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const columnsDocumentacion = [
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 600, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla ?
                        <div style={{ width: '100%', textAlign: 'left' }}>
                            <label>{`${params.row.nameDoc}`}</label>
                        </div>
                        :
                        <div style={{ width: '100%', padding: '3%' }}>
                            <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                        </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'fechaTermino', headerName: '', headerAlign: 'center', width: 140, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.quitarVigencia == true &&
                        <Fragment>
                            <label> Sin vigencia </label>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.quitarVigencia == false &&
                        <Fragment>
                            <label> {`${params.row.fechaTermino}`} </label>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 50, sortable: false,
            renderCell: (params) =>
                <Fragment>
                    {(params.row.nameDoc != 'Dictamen de cumplimiento con la NOM de instalaciones' && params.row.nameDoc != 'Informe de cumplimiento con la NOM') ?
                        <Fragment>
                            {(params.row.tabla != null && (params.row.nameDoc == 'Solicitud de inscripción' || params.row.nameDoc == 'Plan de evaluación' ||
                                params.row.nameDoc == 'Solicitud de servicios de inspección')) &&
                                <BotonVerArchivoComponent url={`InformacionCliente/servirArchivoFC01/idSolicitud=${params?.row?.idfc01_solicitudregistro}&idoficio=${params?.row?.idoficio}`} />
                            }
                            {(params.row.tabla != null && params.row.nameDoc == 'Informe con la documentación juridica') &&
                                <BotonVerArchivoComponent url={`InformacionCliente/servirArchivoJuridico/idcliente=${params?.row?.idcliente}`} />
                            }
                            {(params.row.tabla != null && params.row.nameDoc == 'Informe con la documentación fiscal') &&
                                <BotonVerArchivoComponent url={`InformacionCliente/servirArchivoFiscal/idcliente=${params?.row?.idcliente}`} />
                            }
                            {(params.row.tabla != null && params.row.name == 'Informe con la documentación marcaria') &&
                                <BotonVerArchivoComponent url={`InformacionCliente/servirAchivoDictamenes/iddictamenmarcariocliente=${params?.row?.iddictamenmarcariocliente}`} />
                            }
                            {(params.row.tabla != null && params.row.tipo == 'certificado' && params.row.idSolicitud != null && params.row.idSolicitud != '') &&
                                <BotonVerArchivoComponent url={`InformacionCliente/servirDocumentacion/tabla=${params?.row?.tabla}&nombreid=${params?.row?.nombreid}&idSolicitud=${params?.row?.idSolicitud}`} />
                            }
                        </Fragment>
                        :
                        <Fragment>
                            {/*<IconButton onClick={() => dictamenes()}>
                                <FolderZipIcon sx={{ color: '#31549a', width: '100%' }}></FolderZipIcon>
                            </IconButton>*/}
                            <button onClick={() => dictamenes(params.row)} className={`btn ${estilos.btnAzul}`}><VisibilityRoundedIcon style={{ transform: 'scale(1.5)' }} icon={faFileInvoice} /></button>
                            {
                                openModal &&
                                <ModalMensajeComponent setOpenModal={{ setOpenModal }} titleModal={'Error'} bodyModal={'No hay archivos adjuntos'}></ModalMensajeComponent>
                            }
                            {/** 
             * <BotonDescargarZipComponent url={`FC_01/servirAchivosGenerales/tabla=${'fi_25_documenentos'}&nombreId=${'idfi_25_documentos'}&idSolicitud=${file.idfi_25_documentos}&idoficio=${24}`} tabla={'documentodictamenmarcario'} />
            */}
                        </Fragment>
                    }
                </Fragment>
        },
        {
            field: 'accion', headerName: '', headerAlign: 'center', width: 50, sortable: false,
            renderCell: (params) =>
                <Fragment>
                    {params.row.sustituir &&
                        <Fragment>
                            <Tooltip title="Sustituir archivo"><IconButton size="large" onClick={() => sustituir(params)} > <FileUploadRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.rechazar &&
                        <Fragment>
                            <BotonRechazarDictamenComponent />
                        </Fragment>
                    }
                </Fragment>
        },
        {
            field: 'file', headerName: '', headerAlign: 'center', width: 50, sortable: false,
            renderCell: (params) =>
                <Fragment>
                    {params.row.sustituir &&
                        <Fragment>
                            {params.row.nameDoc == 'Certificado NOM como productor, envasador, comercializador FC_13' &&
                                <GenerarCertificadoFC13Component solicitud={detalleCliente?.login?.cliente?.[0]} />
                            }
                            {params.row.nameDoc == 'Constancia de cumplimiento con la NOM FC_37' &&
                                <GenerarCertificadoFC37Component data={detalleCliente} />
                            }
                            {params.row.nameDoc == 'Dictamen de cumplimiento de comercializador FC_27' &&
                                <DictamenCumplimientoFC27Component cliente={detalleCliente?.login?.cliente?.[0]} solicitud={informacionCliente} />
                            }
                            {params.row.nameDoc == 'Revisión de evaluación y decisión de la certificación' &&
                                <RevisionEvaluacionDecisionComponent cliente={detalleCliente?.login?.cliente?.[0]} />
                            }
                        </Fragment>
                    }
                </Fragment>
        },
    ]

    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }

    const dictamenes = async (params) => {
        let oficio= 0
        if(params.nameDoc== 'Dictamen de cumplimiento con la NOM de instalaciones')oficio=24
        if(params.nameDoc== 'Informe de cumplimiento con la NOM')oficio=23
        const data = { idoficio: oficio, idsolicitudesuifc01: informacionCliente.idsolicitudesuifc01 }
        let res = await dispatch(obtenerDictamen(data))
        const merger = new PDFMerger();

        for (let file of res.payload) {
            //const fileFetch = await fetch(host + `Guias/servirArchivo/iddatospredio=${iddatospredio}&idconstancia=${file.idconstancia}`)
            const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fi_25_documenentos'}&nombreId=${'idfi_25_documentos'}&idSolicitud=${file.idfi_25_documentos}&idoficio=${oficio}`)
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            await merger.add(url)
        }
        //merger.save(`Registropredioguias_${iddatospredio}`)
        const mergedPdf = await merger.saveAsBlob();
        let url = window.URL.createObjectURL(mergedPdf, { type: 'application/pdf' });
        window.open(url);
    }

    const [modalConfirmar, setModalConfirmar] = React.useState(false);
    const handleOpenConfirmar = (values) => {
        setModalConfirmar(true);
    }
    const handleCloseConfirmar = () => {
        setModalConfirmar(false);
    }
    const ModalConfirmar = () => {
        return (
            <Modal
                open={modalConfirmar}
                onClose={handleCloseConfirmar}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={styleParaModalDeDocumentos} >
                    <h3>Advertencia</h3>
                    <FormularioDocumentacion functionAcept={AceptarSolcitud} data={informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]} />
                </Box>

            </Modal>
        )
    }
    const AceptarSolcitud = async (valueForm) => {
        await dispatch(actualizarLoadingApp_true())
        let cliente = informacionCliente?.fc_01_solicitudderegistro?.login?.cliente?.[0]

        let dataAsignacion = {
            idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0]?.idsolicitudesocfc01, idestatusoc: 2,
            dataseguimiento: {
                numerosocio: valueForm?.numeroDeCliente, telefonoEmpresa: cliente?.telefono,
                nombrerazonsocial: cliente?.nombrerazonsocial, correoElectronicoEmpresa: cliente?.correoelectronico,
                tipoPersona: cliente?.personafisica == true ? 'Fisica' : 'Moral',
                checkFabrica: false, checkProductor: false, checkNacional: false,
                checkEnvasadora: false, checkEnvasador: false, checkExportacion: false,
                checkGranel: false, checkComercializador: false, checkPromocion: false,
                checkProductoTerminado: false, checkTraslado: false, checkMaduracion: false,
                checkDitamenMarcario: false, numCertificadoNOM: '', numeroTraslado: '',

                numerosolicitud: valueForm?.numeroSolicitud, otrosServicios: valueForm.otrosServicios,
                fechaInspeccion: valueForm.fechaInspeccion,

                numeroPlanEvaluacion: valueForm.numeroPlanEvaluacion, inspectorAsignado: valueForm.inspectorAsignado,
                credencialInspector: valueForm.credencialInspector, telefonoInspector: valueForm.telefonoInspector,

                idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0].idsolicitudesocfc01,
                nombrerepresentantelegal: cliente?.nombrerepresentantelegal,
                telefonoRepresentante: cliente?.telefonorepresentante,
                correoElectronicoRepresentante: cliente?.correoelectronicorepresentante

            }
        }
        await dispatch(actualizarFC01_OCAccion(dataAsignacion))
        const dataAceptar = {
            numerosocio: valueForm?.numeroDeCliente, telefonoEmpresa: cliente?.telefono,
            nombrerazonsocial: cliente?.nombrerazonsocial, correoElectronicoEmpresa: cliente?.correoelectronico,
            tipoPersona: cliente?.personafisica == true ? 'Fisica' : 'Moral',
            checkFabrica: false, checkProductor: false, checkNacional: false,
            checkEnvasadora: false, checkEnvasador: false, checkExportacion: false,
            checkGranel: false, checkComercializador: false, checkPromocion: false,
            checkProductoTerminado: false, checkTraslado: false, checkMaduracion: false,
            checkDitamenMarcario: false, numCertificadoNOM: '', numeroTraslado: '',

            numerosolicitud: valueForm?.numeroSolicitud, otrosServicios: valueForm.otrosServicios,
            fechaInspeccion: valueForm.fechaInspeccion,

            numeroPlanEvaluacion: valueForm.numeroPlanEvaluacion, inspectorAsignado: valueForm.inspectorAsignado,
            credencialInspector: valueForm.credencialInspector, telefonoInspector: valueForm.telefonoInspector,

            instalaciones: cliente?.anexocliente,

            idsolicitudesocfc01: informacionCliente?.ocsolicitudfc01?.[0].idsolicitudesocfc01,
            nombrerepresentantelegal: cliente?.nombrerepresentantelegal,
            telefonoRepresentante: cliente?.telefonorepresentante,
            correoElectronicoRepresentante: cliente?.correoelectronicorepresentante

        }
        await dispatch(AceptarSolicitudFC_01(dataAceptar))
        handleCloseConfirmar()
        if (dataUser[0]?.idrol == 1) await dispatch(obtenerSolicitudesFC01SeguimientoNacionalAdmin(2))
        if (dataUser[0]?.idrol == 7) await dispatch(obtenerSolicitudesFC01SeguimientoNacionalAuxiliar(dataUser?.[0].usuario))
        await dispatch(actualizarLoadingApp_false())
        history.push('/SeguimientoComponent')
    }

    return (
        <Fragment >
            <div style={{ margin: 0, padding: 0, marginTop: '6%' }}>
                <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47', fontFamily: 'Montserrat' }} >DOCUMENTACION</h5>
                <Box sx={{ height: 900, width: '90%', m: 'auto', mt: 2 }}>
                    <DataGrid
                        rows={rowsDocumentacionGeneral}
                        columns={columnsDocumentacion}
                        rowsPerPageOptions={[50]}
                        headerHeight={0}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            backgroundColor: 'white',
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#4399A4',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '5px'
                            },
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily: 'Montserrat',
                            },
                        }}
                    />
                </Box>
            </div>
            {openModalSustituir &&
                <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} />
            }
            <div className="row text-center">
                <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                    <button type="submit" className={`btn ${estilos.botonNaranjaRedondo}`} onClick={() => handleOpenConfirmar()}> Aceptar</button>
                </div>
            </div>
            {ModalConfirmar()}
        </Fragment>
    )
}

export default DocumentacionGeneralComponent